import { EventEmitter, Input, Output, Directive } from '@angular/core';

import { ListProperty, User } from '@site-mate/dashpivot-shared-library';

import { ListPropertyColumnMovedEvent } from '../list-header-edit/list-property-column-moved.interface';

@Directive()
export abstract class AbstractListHeader {
  @Input() index: number;
  @Input() isLast: boolean;
  @Input() property: ListProperty;
  @Input() editable = true;
  @Input() users: User[];
  @Output() readonly propertyChanged = new EventEmitter<ListProperty>();
  @Output() readonly propertyDeleted = new EventEmitter<ListProperty>();
  @Output() readonly onPropertyMoved = new EventEmitter<ListPropertyColumnMovedEvent>();
  @Output() readonly onRequestAddProperty = new EventEmitter<number>();

  onPropertyChanged(updatedData: Partial<ListProperty>): void {
    if (this.editable) {
      this.propertyChanged.emit({ ...this.property, ...updatedData });
    }
  }

  onPropertyDeleted(): void {
    if (this.editable) {
      this.propertyDeleted.emit({ ...this.property });
    }
  }
}
